var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4894 45.3166H8.02353C7.63503 45.3166 7.32031 45.0018 7.32031 44.6134C7.32031 44.2249 7.63503 43.9102 8.02353 43.9102H35.4895C35.878 43.9102 36.1927 44.2249 36.1927 44.6134C36.1926 45.0018 35.8779 45.3166 35.4894 45.3166Z",
    fill: "#3C5156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4122 38.3506L12.33 25.2684C12.1981 25.1366 12.0194 25.0625 11.8327 25.0625C11.6462 25.0625 11.4674 25.1366 11.3354 25.2684L0.492399 36.1115C-0.164133 36.7681 -0.164133 37.8364 0.492399 38.4931L6.81969 44.8204C7.14172 45.1423 7.5696 45.3195 8.02485 45.3195H18.7322C19.1873 45.3195 19.6153 45.1422 19.9372 44.8204L25.4123 39.3452C25.6869 39.0705 25.6869 38.6253 25.4122 38.3506Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4108 38.3518L23.723 36.6641L15.0664 45.3207H18.7306C19.1858 45.3207 19.6138 45.1434 19.9357 44.8215L25.4108 39.3463C25.6855 39.0718 25.6855 38.6266 25.4108 38.3518Z",
    fill: "#C6C5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7511 18.578L32.101 2.92789C31.77 2.59705 31.2317 2.59686 30.9005 2.92789L10.0503 23.7781C9.72014 24.1088 9.72014 24.6469 10.0507 24.9781L25.7009 40.6282C25.8665 40.7937 26.0838 40.8763 26.3011 40.8763C26.5184 40.8763 26.7358 40.7936 26.9013 40.6282L47.751 19.7785C48.0821 19.4475 48.0821 18.9091 47.7511 18.578Z",
    fill: "#39A4FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7502 18.5808L46.2592 17.0898L24.209 39.1401L25.7 40.6311C25.8655 40.7965 26.0829 40.8791 26.3002 40.8791C26.5175 40.8791 26.7349 40.7965 26.9004 40.6311L47.7501 19.7813C48.0812 19.4504 48.0812 18.912 47.7502 18.5808Z",
    fill: "#0091E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.f8cade8e4fe3de459a1a57adc4f2b9a7.svg";
export { ForwardRef as ReactComponent };